import React, { useEffect, useState } from 'react'
import { useAppData } from '../../../../../context/AppDataContext'
import { Link } from 'react-router-dom';
import { Autocomplete, IconButton, TextField, Tooltip } from '@mui/material';
import { Add, Cancel, Delete, Print } from '@mui/icons-material';
import projectTeamServices from '../projectTeamServices';
import { useAlert } from '../../../../../context/AlertContext';
import EmployeeForm from '../../employee/components/EmployeeForm';

function ProjectTeam({projectId,autoload=false}) {

    const {employeeDD,getMasterLabel,getEmployeeDD} = useAppData();
    const {AppAlert} = useAlert();
    const [teamList,setTeamList] = useState(null);
    

    const [selectedEmploye,setSelectedEmployee] = useState(null)

    const getProjectTeam = () =>{
        console.log("getting ProjectTeam");
        projectTeamServices.getByProjectId(projectId).then(res=>{
            console.log("here");
            setTeamList(res.data)
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            console.log("finnaly")
        })
    }


    const addToTeam = () => {
        let payload = {
            projectId:projectId,
            employeeId:selectedEmploye.value
        }

        projectTeamServices.save(payload).then(res=>{
            AppAlert(res.msg)
            getProjectTeam();
        }).catch(error=>{
            AppAlert(error.msg,"error")
        })
    }

    const remove = (teamId) =>{
        projectTeamServices.remove(teamId).then(res=>{
            getProjectTeam();
            AppAlert(res.msg)
            
        }).catch(error=>{
            AppAlert(error.msg,"error")
        })
    }

    useEffect(()=>{
        if(autoload){
            getProjectTeam();
        }
    },[])

    return (
        <>
        {!teamList && <button className='btn btn-outline-primary mt-2' onClick={()=>getProjectTeam()}  >View Team</button> }
        
        {teamList && <div className='card mt-2'>
            <div className='card-header bg-dark text-info'> 
                    Team  
                    <span className='ms-2'><EmployeeForm callBack={getEmployeeDD} /></span>
                    <Link className='btn btn-warning btn-sm float-end' to={"/project/team-details/"+projectId}> <Print/></Link>
                </div>
                <div className="list-group border-0">
                    {teamList && teamList.map((employee,i)=>
                        <div className='list-group-item' key={i}>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <span className='text-primary'>{employee.employeeName} </span> <span className='fw-bold'>Phone : </span>{employee.phone}        
                                </div>
                                <Tooltip title="Remove From Project">
                                    <IconButton className='text-danger p-0' onClick={()=>remove(employee.teamId)} ><Cancel/></IconButton>
                                </Tooltip>
                            </div>
                        </div>
                    )}
                    {teamList &&
                    <div className='list-group-item'>
                        <div className="d-flex justify-content-between">
                            <div className='w-100'>
                                <Autocomplete
                                    options={employeeDD}
                                    onChange={(event, newValue) => {
                                        setSelectedEmployee(newValue);
                                    }}
                                    className='bg-white'
                                    value={selectedEmploye}
                                    renderInput={(params) => <TextField {...params} size="small" /> } 
                                />
                            </div>
                            <button className='btn btn-outline-primary' onClick={addToTeam} ><Add/></button>
                        </div>
                    </div>
                    }
                </div>
            </div>
        }
        </>
    )
}

export default ProjectTeam